import React from "react";
import { Card, Typography } from "antd";
import { DocumentTitle } from "../../components";
import I18n from "../../i18n";

export default function Terms() {
  return (
    <DocumentTitle title={I18n.general.termsAndConditions}>
      <Card
        style={{ margin: 32, boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.4)" }}
        title={
          <Typography.Title level={2} style={{ paddingBottom: 0, marginBottom: 0 }}>
            {I18n.general.termsAndConditions}
          </Typography.Title>
        }
      >
        <Typography.Title level={5}>شرایط مرجوعی</Typography.Title>
        <Typography.Paragraph>
          محصولات ارسالی فروشگاه لِنا استایل در صورت مغایرت داشتن رنگ یا سایز
          بدون جدا شدن برچسب کالا و بدون بوی بدن و عطر، کاملا مطابق بسته ارسالی
          تا ۳ روز از زمان دریافت با هماهنگی با پشتیبانی قابلیت برگشت دارند.
          لطفا قبل از ارسال حتما با پشتیبانی هماهنگی کنید و از ارسال بدون
          هماهنگی پرهیز نمایید.
        </Typography.Paragraph>
      </Card>
    </DocumentTitle>
  );
}
